import { Container, Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import HistoryRowControls from 'Components/HistoryRowControls';
import { withHistoryContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { sortDocumentsDescending } from 'Utility/documentHandling';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'ariaSymptoms'>[] = [];
const AriaSymptomsHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'ariaSymptoms'>>): React.JSX.Element => {
  return (
    <React.Fragment>
      {documents.toSorted(sortDocumentsDescending).map(d => (
        <HistoryRow
          headerText={d.date ? formatPartialDate(d.date) : undefined}
          key={d._id}
          rowButton={startEdit && <HistoryRowControls document={d} startEdit={startEdit} />}
          controlsMargin={false}
        >
          <Container>
            <Item xs={3}>
              <HistoryRowBasicItem
                header={fm('ariaSymptoms.symptomsFound')}
                value={d.symptomsFound ? fm(`general.${d.symptomsFound}`) : '-'}
              />
            </Item>
            <Item xs={3}>
              {d.symptoms ? (
                <HistoryRowBasicItem
                  header={fm('ariaSymptoms.symptoms')}
                  value={
                    <div>
                      {d.symptoms.map(symp => (
                        <div key={symp}>{fm(`ariaSymptoms.opts.${symp}`)}</div>
                      ))}
                    </div>
                  }
                />
              ) : (
                <></>
              )}
            </Item>
            <Item xs={true}>
              <HistoryRowBasicItem header={fm('ariaSymptoms.additionalInformation')} value={d.additionalInformation} />
            </Item>
          </Container>
        </HistoryRow>
      ))}
    </React.Fragment>
  );
};

export default withHistoryContext(AriaSymptomsHistory);
